export function GlobalErrorFallback({ resetError }: { resetError: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 bg-gray-50">
      <div className="flex flex-col items-center gap-4 max-w-xs text-center">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <h1 className="text-title6 text-gray-1000">An unexpected error occurred</h1>
        <p className="text-body3 text-gray-500">
          Please try again. If the problem persists, contact your administrator.
        </p>
        <div className="flex gap-2 mt-2 flex-col w-full">
          <button
            type="button"
            onClick={resetError}
            className="px-6 py-2.5 text-body3 font-medium text-white bg-gray-900 rounded-8 hover:bg-gray-800 transition-colors w-full"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => window.location.replace("/")}
            className="px-6 py-2.5 text-body3 font-medium text-gray-700 bg-white border border-gray-300 rounded-8 hover:bg-gray-50 transition-colors w-full"
          >
            Go to Home
          </button>
        </div>
        <p className="text-caption1 text-gray-400 mt-4">Build: {__BUILD_HASH__}</p>
      </div>
    </div>
  );
}
